









































































import Vue from "vue"
import LayoutHeader from "@/layout/header/LayoutHeader.vue"
import LayoutDrawer from "@/layout/drawer/LayoutDrawer.vue"
import ErrorPage from "@/layout/error/ErrorPage.vue"

export default Vue.extend({
  components: {LayoutHeader, LayoutDrawer, ErrorPage},
  data() {
    return {
      clientDetails: true,
      quickLinks: true,
      downloads: false,
      settings: false
    }
  }
})
